import { Observable } from 'rxjs'
import { JobTitle } from '../../../models'

export abstract class MbJobTitlesAdapter {

  abstract load(): Observable<JobTitle[]>
}
